module.exports = __webpack_public_path__ + "img/new3.2059713e.webp";